import { api } from './api';

export interface VaultPrincipal {
  tenantId: string;
  email: string;
  enabled: boolean;
  addedBy: string;
  addedAtEpoch: number;
  lastCheckoutAtEpoch?: number;
  notes?: string;
}

export const vaultService = {
  /** Tenants the current JWT principal is authorized for. */
  async myTenants(): Promise<VaultPrincipal[]> {
    return api.get<VaultPrincipal[]>('/clio-bot/vault/my-tenants');
  },

  /** Request the bot password by email. Returns nothing — caller checks inbox. */
  async checkoutPassword(tenantId: string, purpose?: string): Promise<void> {
    await api.post<void>(`/clio-bot/vault/${encodeURIComponent(tenantId)}/credentials/checkout`, {
      ...(purpose ? { purpose } : {}),
    });
  },

  /** Release the caller's credential checkout. Once everyone releases, the
   * next checkout rotates the password. */
  async releaseCredential(tenantId: string): Promise<void> {
    await api.delete<void>(
      `/clio-bot/vault/${encodeURIComponent(tenantId)}/credentials/release`,
    );
  },

  /** otpauth URL for client-side QR rendering. The PNG never crosses the wire. */
  async getMfaOtpauth(tenantId: string): Promise<{ otpauth: string }> {
    return api.get<{ otpauth: string }>(`/clio-bot/vault/${encodeURIComponent(tenantId)}/mfa`);
  },

  // ── Admin (Coral Edge only) ────────────────────────────────────────────

  async listPrincipals(tenantId: string): Promise<VaultPrincipal[]> {
    return api.get<VaultPrincipal[]>(`/clio-bot/vault/${encodeURIComponent(tenantId)}/principals`);
  },

  async addPrincipal(tenantId: string, email: string, notes?: string): Promise<VaultPrincipal> {
    return api.post<VaultPrincipal>(`/clio-bot/vault/${encodeURIComponent(tenantId)}/principals`, {
      email,
      ...(notes ? { notes } : {}),
    });
  },

  async removePrincipal(tenantId: string, email: string): Promise<void> {
    await api.delete<void>(
      `/clio-bot/vault/${encodeURIComponent(tenantId)}/principals/${encodeURIComponent(email)}`,
    );
  },
};
